import { render, staticRenderFns } from "./SponsorCounter.vue?vue&type=template&id=80ce7226"
import script from "./SponsorCounter.vue?vue&type=script&lang=js"
export * from "./SponsorCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports